"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProductStaticWellKnownMapping_1 = require("@CommonFrontendBackend/QuoteV2/ProductStaticWellKnownMapping");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var VariableStore_1 = __importDefault(require("QuoteV2/Stores/VariableStore"));
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var c = (0, BemBuilder_1.default)("section");
var ItemRate = (function (_super) {
    __extends(ItemRate, _super);
    function ItemRate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemRate.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var item = this.props.item;
        var formatWithCurrency = function (val) {
            return _this.quoteCurrencyFormatter.formatWithUserDecimalPreference(val, { round: false });
        };
        if (item instanceof QuoteItemStore_1.QuoteFixedCostItemStore) {
            return react_1.default.createElement("span", { className: c("rate") }, formatWithCurrency(item.rate));
        }
        if (item instanceof QuoteItemStore_1.QuoteVariableItemStore) {
            var rate = item.rate ? (_b = (_a = this.variableStore.getVariable(item.rate)) === null || _a === void 0 ? void 0 : _a.getAmount(item.quantity)) !== null && _b !== void 0 ? _b : 0 : 0;
            return react_1.default.createElement("span", { className: c("rate") }, formatWithCurrency(rate));
        }
        if (item instanceof QuoteItemStore_1.QuoteProductItemStore) {
            return (react_1.default.createElement("span", { className: c("rate") }, "p.".concat(ProductStaticWellKnownMapping_1.ProductStaticWellKnownMapping.getMappedProductFieldName(Types_1.ProductMappedField.Rate, (_c = item.token.substitutionToken) === null || _c === void 0 ? void 0 : _c.id))));
        }
        return null;
    };
    var _a, _b;
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_a = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _a : Object)
    ], ItemRate.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof VariableStore_1.default !== "undefined" && VariableStore_1.default) === "function" ? _b : Object)
    ], ItemRate.prototype, "variableStore", void 0);
    ItemRate = __decorate([
        mobx_react_1.observer
    ], ItemRate);
    return ItemRate;
}(react_1.default.Component));
exports.default = ItemRate;
